export default "__VITE_ASSET__DMyXHaPj__"